import Vue from 'vue'

const state = {
  processes: [],
  detailsModalClosedByUser: false,
  shouldOpenDetailsModal: false,
  fromClient: null,
  toClient: null,
  clients: []
}

const getters = {
  hasActiveProcesses: (state) => {
    return state.processes.length > 0
  },
  hasProcessingJobs: (state) => {
    return state.processes.some(p => p.status === 'processing')
  },
  allCompleted: (state) => {
    if (state.processes.length === 0) return false
    return state.processes.every(p => p.status === 'success' || p.status === 'error')
  },
  allSuccess: (state) => {
    if (state.processes.length === 0) return false
    return state.processes.every(p => p.status === 'success')
  },
  hasError: (state) => {
    return state.processes.some(p => p.status === 'error')
  },
  aggregatedResults: (state) => {
    return {
      created: state.processes.reduce((sum, p) => sum + (p.results?.created || 0), 0),
      substituted: state.processes.reduce((sum, p) => sum + (p.results?.substituted || 0), 0),
      ignored: state.processes.reduce((sum, p) => sum + (p.results?.ignored || 0), 0),
      details: state.processes.flatMap(p => p.results?.details || [])
    }
  }
}

const mutations = {
  SET_PROCESSES: (state, processes) => {
    state.processes = processes
  },
  UPDATE_PROCESS: (state, { room, updates }) => {
    const processIndex = state.processes.findIndex(p => p.room === room)
    if (processIndex !== -1) {
      Vue.set(state.processes, processIndex, {
        ...state.processes[processIndex],
        ...updates
      })
    }
  },
  CLEAR_PROCESSES: (state) => {
    state.processes = []
    state.detailsModalClosedByUser = false
    state.shouldOpenDetailsModal = false
    state.fromClient = null
    state.toClient = null
    state.clients = []
  },
  SET_DETAILS_MODAL_CLOSED_BY_USER: (state, value) => {
    state.detailsModalClosedByUser = value
  },
  SET_SHOULD_OPEN_DETAILS_MODAL: (state, value) => {
    state.shouldOpenDetailsModal = value
  },
  SET_CLIENTS: (state, { fromClient, toClient, clients }) => {
    state.fromClient = fromClient
    state.toClient = toClient
    if (clients) {
      state.clients = clients
    }
  }
}

const actions = {
  initializeProcesses({ commit }, { processes, fromClient, toClient, clients }) {
    commit('SET_PROCESSES', processes)
    commit('SET_CLIENTS', { fromClient, toClient, clients })
    commit('SET_DETAILS_MODAL_CLOSED_BY_USER', false)
  },
  updateProcessProgress(
    { commit },
    { room, message, messageKey, messageParams, progress, processed, total, results }
  ) {
    commit('UPDATE_PROCESS', {
      room,
      updates: {
        message,
        messageKey,
        messageParams,
        progress,
        processed,
        total,
        results
      }
    })
  },
  markProcessCompleted({ commit }, { room, results }) {
    commit('UPDATE_PROCESS', {
      room,
      updates: { status: 'success', results, progress: 100 }
    })
  },
  markProcessFailed({ commit }, { room, error }) {
    commit('UPDATE_PROCESS', {
      room,
      updates: { status: 'error', error }
    })
  },
  setDetailsModalClosedByUser({ commit }, value) {
    commit('SET_DETAILS_MODAL_CLOSED_BY_USER', value)
  },
  setShouldOpenDetailsModal({ commit }, value) {
    commit('SET_SHOULD_OPEN_DETAILS_MODAL', value)
  },
  clearProcesses({ commit }) {
    commit('CLEAR_PROCESSES')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
